module.exports = __webpack_public_path__ + "static/Event-managment-cd2deebda7dd25c59ffa5fa3f4adf7c9.svg";